import { render, staticRenderFns } from "./attachment-previews.vue?vue&type=template&id=ce0036ec"
import script from "./attachment-previews.js?vue&type=script&lang=js&external"
export * from "./attachment-previews.js?vue&type=script&lang=js&external"
import style0 from "./attachment-previews.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports